import { render, staticRenderFns } from "./CurrencyRates.vue?vue&type=template&id=c1725dba&scoped=true&"
import script from "./CurrencyRates.vue?vue&type=script&lang=ts&"
export * from "./CurrencyRates.vue?vue&type=script&lang=ts&"
import style0 from "./CurrencyRates.vue?vue&type=style&index=0&id=c1725dba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1725dba",
  null
  
)

export default component.exports